import { useEffect } from "preact/hooks";
import { RefObject } from "preact";
import { useRef } from "preact/hooks";
export { getAddressCount } from "./selectionHelpers";

export const useClickInside = (
    ref: RefObject<HTMLElement>,
    callback: () => void,
) => {
    const callbackRef = useRef(callback);
    callbackRef.current = callback;
    useEffect(() => {
        const handleClick = (e: Event) => {
            if (e.target instanceof Node && ref.current?.contains(e.target)) {
                callbackRef.current();
            }
        };
        document.addEventListener("click", handleClick);
        return () => {
            document.removeEventListener("click", handleClick);
        };
    }, [ref]);
};

export const uuidv4 = () => {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
            const r = (Math.random() * 16) | 0,
                v = c === "x" ? r : (r & 0x3) | 0x8;
            return v.toString(16);
        },
    );
};

export const formatCurrencyValue = (value: number) => {
    return new Intl.NumberFormat("nl-NL", {
        style: "currency",
        currency: "EUR",
    }).format(value);
};

export const withoutKeys = <T extends object, K extends keyof T>(
    obj: T,
    keys: K[],
): Omit<T, K> => {
    const result = { ...obj };
    keys.forEach((key) => delete result[key]);
    return result;
};
